export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_AGENCY_BM-d9a84d60c6de008baf659cdaa0e44e98.pdf";